function showSparePartsPopup() {
  document.getElementById('spare-popup-bg').style.display = 'block';
  document.getElementById('spare-popup').classList.add('show');
  document.body.style.overflow = 'hidden';
}

function spareHidePopup() {
  document.getElementById('spare-popup-bg').style.display = 'none';
  document.getElementById('spare-popup').classList.remove('show');
  document.body.style.overflow = 'scroll';
}

// Function to toggle the Add to Cart button state
function toggleSpareAddToCartButton() {
  const sparePopup = document.getElementById('spare-popup');
  if (!sparePopup) return;

  const submitButton = sparePopup.querySelector("#spare-add-to-cart");
  const checkedCheckboxes = sparePopup.querySelectorAll(".spare_product_checkbox:checked");
  submitButton.disabled = checkedCheckboxes.length === 0;  // Disable the button if no checkboxes are checked
}

// Attach event listener to all checkboxes
document.querySelectorAll(".spare_product_checkbox")?.forEach((checkbox) => {
  checkbox.addEventListener("change", toggleSpareAddToCartButton);
});

const spareAddToCart = document.querySelector("#spare-add-to-cart");
 var status = {
    loading: false,
  };

if (spareAddToCart) {
  spareAddToCart.addEventListener("click", function (event) {
    event.preventDefault();
    if (status.loading) {
          return;
      }
    const sparePopup = document.getElementById("spare-popup");
    if (!sparePopup) return;
    const checkedCheckboxes = sparePopup.querySelectorAll(".spare_product_checkbox:checked");
    if (checkedCheckboxes.length === 0) {
      alert("Please select at least one spare part to add to the cart.");
      return;
    }
    
    const itemsToAdd = Array.from(checkedCheckboxes).map((checkbox) => {
      // Find the variant selector dropdown for the selected checkbox
      const parentItem = checkbox.closest(".spare_product_product-item");
      const variantSelect = parentItem.querySelector(".spare_product_variant_select");

      // Use the selected variant ID or fallback to the checkbox's data-id
      const selectedVariantId = variantSelect ? variantSelect.value : checkbox.dataset.id;

      return {
        id: selectedVariantId,
        quantity: parseInt(checkbox.dataset.quantity, 10) || 1,
      };
    });

    const submitButton = sparePopup.querySelector("#spare-add-to-cart");
    submitButton.classList.add("btn--loading");
     status.loading = true;

    const data = { items: itemsToAdd };

    fetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then(function (data) {
        var product = data;
        spareAddToCart.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: submitButton,
            },
            bubbles: true,
          })
        );
        
        status.loading = false;
        submitButton.classList.remove("btn--loading");
        // Clear checked checkboxes
        checkedCheckboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      
        toggleSpareAddToCartButton();
        spareHidePopup();
      })
      .catch((error) => {
        alert("There was an issue adding items to the cart. Please try again.");
        submitButton.classList.remove("btn--loading");
      });
  });
}

// Close popup when clicking outside of it
document.getElementById('spare-popup-bg')?.addEventListener('click', function (event) {
  const sparePopup = document.getElementById('spare-popup');
  if (event.target === this) {
    spareHidePopup();
  }
});


document.addEventListener("DOMContentLoaded", function () {
   toggleSpareAddToCartButton(); // Initialize button state on page load
  
  // Attach event listeners to variant dropdowns
  document.querySelectorAll(".spare_product_variant_select").forEach((dropdown) => {
    dropdown.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex]; // Get the selected option
      const newImageUrl = selectedOption.dataset.image;  // Get the image URL from the data-image attribute
      
      // Find the image element within the same product item
      const parentItem = this.closest(".spare_product_product-item");
      const productImage = parentItem.querySelector(".spare_product_image");
      
      // Update the image source
      if (productImage && newImageUrl) {
        productImage.src = newImageUrl;
      }
    });
  });
});

